export const SITE_URL = "https://www.suriwebwinkel.nl";
export const SITE_NAME = "Suriwebwinkel";
export const DEFAULT_TITLE = "Suriwebwinkel — Het is zo simpel.";
export const DEFAULT_DESCRIPTION =
  "Bestel vanuit Europa boodschappen, cadeaus en benodigdheden voor familie in Suriname. Geen dozen opsturen — lokaal bezorgd. Suriwebwinkel: het is zo simpel.";
export const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;
export const DEFAULT_KEYWORDS = [
  "Suriwebwinkel",
  "boodschappen Suriname",
  "bestellen Suriname vanuit Nederland",
  "bestellen Suriname vanuit Europa",
  "familiepakket Suriname",
  "cadeau Suriname",
  "bezorging Suriname",
  "Paramaribo boodschappen",
  "verlanglijst Suriname",
  "het is zo simpel",
].join(", ");

/** Per-route SEO copy */
export const PAGE_SEO = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/producten": {
    title: "Producten & boodschappen voor Suriname | Suriwebwinkel",
    description:
      "Bekijk boodschappen, verzorging, huishouden, babyproducten en cadeaus. Bestel vanuit Europa, wij bezorgen in Suriname. Het is zo simpel.",
  },
  "/pakketten": {
    title: "Familiepakketten voor Suriname | Suriwebwinkel",
    description:
      "Samengestelde familiepakketten: boodschappen, Mama & Papa, baby, verjaardag en meer. Bestel vanuit Europa — Suriwebwinkel bezorgt lokaal.",
  },
  "/hoe-het-werkt": {
    title: "Hoe werkt Suriwebwinkel? | Van betaling tot blij moment",
    description:
      "Van betaalde bestelling tot lokale bezorging in Suriname — en een privé bezorgfoto via de app en e-mail. Zo werkt Suriwebwinkel. Het is zo simpel.",
  },
  "/verlanglijst": {
    title: "Verlanglijst delen met familie in Europa | Suriwebwinkel",
    description:
      "Laat de ontvanger in Suriname een verlanglijst maken. Jij betaalt vanuit Europa, wij bezorgen. Het is zo simpel.",
  },
  "/familieplan": {
    title: "Familieplan — maandelijks ondersteunen | Suriwebwinkel",
    description:
      "Stuur iedere maand boodschappen of een pakket naar Suriname met het Familieplan. Herinneringen inbegrepen. Het is zo simpel.",
  },
  "/momenten": {
    title: "Bijzondere momenten in Suriname vieren | Suriwebwinkel",
    description:
      "Verjaardag, Moederdag, Vaderdag, Owru Yari, Kerst of schoolstart: bestel een cadeau of pakket vanuit Europa. Het is zo simpel.",
  },
  "/waarom": {
    title: "Waarom Suriwebwinkel? | Meer controle dan geld sturen",
    description:
      "Lokale bezorging in Suriname, veilig betalen vanuit Europa en precies zien wat je familie ontvangt. Suriwebwinkel — het is zo simpel.",
  },
  "/europa": {
    title: "Bestellen vanuit Europa naar Suriname | Suriwebwinkel",
    description:
      "Bestel vanuit Nederland, België, Duitsland, Frankrijk, het VK en meer. Betaal online, wij bezorgen in Suriname. Het is zo simpel.",
  },
  "/zakelijk": {
    title: "Zakelijke bestellingen & donaties | Suriwebwinkel",
    description:
      "Personeelspakketten, relatiegeschenken, donaties en groepsbestellingen voor Suriname. Vraag een offerte aan bij Suriwebwinkel.",
  },
  "/cadeaubon": {
    title: "Suriwebwinkel-cadeaubon | Digitaal cadeau voor Suriname",
    description:
      "Geef een digitale cadeaubon. De ontvanger kiest zelf producten in Suriname. Met persoonlijke boodschap. Het is zo simpel.",
  },
  "/app": {
    title: "Download de Suriwebwinkel-app | iOS & Android",
    description:
      "Bestel en volg bezorgingen via de Suriwebwinkel-app. Beschikbaar in de App Store en Google Play. Het is zo simpel.",
  },
  "/faq": {
    title: "Veelgestelde vragen | Suriwebwinkel",
    description:
      "Antwoorden over bestellen vanuit Europa, bezorging in Suriname, betalen, verlanglijsten en meer. Suriwebwinkel — het is zo simpel.",
  },
  "/contact": {
    title: "Contact | Suriwebwinkel klantenservice",
    description:
      "Neem contact op via WhatsApp of e-mail. Suriwebwinkel helpt je graag met bestellingen naar Suriname. Het is zo simpel.",
  },
  "/privacy": {
    title: "Privacybeleid | Suriwebwinkel",
    description:
      "Lees hoe Suriwebwinkel omgaat met je gegevens in de app en op de website.",
    noindex: false,
  },
  "/terms": {
    title: "Algemene voorwaarden | Suriwebwinkel",
    description:
      "Lees de algemene voorwaarden van Suriwebwinkel B.V. voor bestellingen via de app en website.",
  },
  "/delete-account": {
    title: "Account verwijderen | Suriwebwinkel",
    description:
      "Zo verwijder je je Suriwebwinkel-account via de app of per e-mail.",
  },
  "/change-password": {
    title: "Nieuw wachtwoord instellen | Suriwebwinkel",
    description:
      "Stel een nieuw wachtwoord in voor je Suriwebwinkel-account via de beveiligde reset-link.",
    noindex: true,
  },
};

export function seoForPath(pathname) {
  const key = pathname.replace(/\/$/, "") || "/";
  if (key.startsWith("/change-password")) {
    return PAGE_SEO["/change-password"];
  }
  return PAGE_SEO[key] || {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  };
}
